import { dateToHumanFormat, numberFormatter } from 'components/misc/constants'
import { extractDate } from 'components/misc/functions'
import { Link } from "react-router-dom"

const stageConfig = {
    active:                  { label: 'Active',               dot: 'bg-emerald-500', pill: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-500/10 dark:text-emerald-400 dark:ring-emerald-500/20' },
    completed:               { label: 'Completed',            dot: 'bg-sky-500',     pill: 'bg-sky-50 text-sky-700 ring-sky-600/20 dark:bg-sky-500/10 dark:text-sky-400 dark:ring-sky-500/20' },
    pendingDisbursement:     { label: 'Pending Disbursement', dot: 'bg-amber-400',   pill: 'bg-amber-50 text-amber-700 ring-amber-600/20 dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-500/20' },
    pendingFacilityLetter:   { label: 'Facility Letter',      dot: 'bg-violet-400',  pill: 'bg-violet-50 text-violet-700 ring-violet-600/20 dark:bg-violet-500/10 dark:text-violet-400 dark:ring-violet-500/20' },
    rejected:                { label: 'Rejected',             dot: 'bg-red-500',     pill: 'bg-red-50 text-red-700 ring-red-600/20 dark:bg-red-500/10 dark:text-red-400 dark:ring-red-500/20' },
    default:                 { label: 'In Review',            dot: 'bg-slate-400',   pill: 'bg-slate-50 text-slate-700 ring-slate-600/20 dark:bg-slate-500/10 dark:text-slate-400 dark:ring-slate-500/20' },
};

function LItem({ item }) {
    const stageCandidate = item?.approvalStage || item?.adminStage || item?.state;
    const key = item?.state === 'rejected' ? 'rejected' : (stageConfig[stageCandidate] ? stageCandidate : 'default');
    const { label, dot, pill } = stageConfig[key];

    return (
        <tr className="group border-b border-gray-100 dark:border-white/[.06] hover:bg-gray-50 dark:hover:bg-white/[.03] transition-colors">
            <td className="px-5 py-3.5 text-sm font-medium text-gray-800 dark:text-gray-200 capitalize">
                {item.type}
            </td>
            <td className="px-5 py-3.5 text-sm text-gray-600 dark:text-gray-400 tabular-nums">
                GHS {numberFormatter(item.amount)}
            </td>
            <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">
                {dateToHumanFormat(extractDate(item.date))}
            </td>
            <td className="px-5 py-3.5">
                <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${pill}`}>
                    <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
                    {label}
                </span>
            </td>
            <td className="px-5 py-3.5 text-sm">
                <Link
                    to={`/preview/${item?.state}/${item?.type.toLowerCase()}/${item?._id}`}
                    className="font-medium text-gold-700 hover:text-gold-500 dark:text-gold-400 dark:hover:text-gold-300 transition-colors"
                >
                    View →
                </Link>
            </td>
        </tr>
    )
}

export default LItem
